<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #333;
  -webkit-overflow-scrolling:touch;
  overflow:hidden;
}
.el-main{
  padding:0px !important;
}
.el-radio{
  margin-right:12px;
}
.el-radio__label{
  padding-left:3px;
}
.el-form-item--mini.el-form-item, .el-form-item--small.el-form-item{
  margin-bottom:px !important;
}
.el-form--label-top .el-form-item__label{
  padding-bottom:2px !important;
}
.el-form-item>label{
  color:#000 !important;
}
.el-input > input{
  border:none !important;
  padding:0px !important;
  font-size:1.6rem !important;
  color:#999;
}
.el-form-item__label{
  font-size:1.6rem !important;
}
.el-form-item.is-required:not(.is-no-asterisk) .el-form-item__label-wrap>.el-form-item__label:before, .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before{
    color:#fff !important;
}
.el-textarea__inner{
  font-size:1.6rem;
  color:#999;
}
.el-radio__label{
  font-size:1.4rem;
}
.el-message-box{
  width:74% !important;
}
</style>


// WEBPACK FOOTER //
// src/App.vue